import * as types from "./actions.types";
import { IAppPropsStore } from "./types";

interface ISetAppProps {
  appProps: IAppPropsStore;
  type: types.SET_APP_PROPS;
}
export const setAppProps = (appProps: IAppPropsStore): ISetAppProps => ({
  appProps,
  type: types.SET_APP_PROPS
});

export type Action = ISetAppProps;
